import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);

function load() {
  try {
    const v = JSON.parse(localStorage.getItem("midhq_cart") || "[]");
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("midhq_cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (p) => {
      setItems((prev) => {
        const hit = prev.find((i) => i.id === p.id);
        if (hit) return prev.map((i) => (i.id === p.id ? { ...i, qty: Math.min(i.qty + 1, 50) } : i));
        return [...prev, { id: p.id, name: p.name, price: p.price, image: p.image, qty: 1 }];
      });
      setOpen(true);
    };
    const setQty = (id, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, 50) } : i))));
    const clear = () => setItems([]);
    const total = items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, add, setQty, clear, total, count, open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
